// //***** Thumb images *****//
// var workThumbs = function() {
//   $(".work-index ul li").hover(
//     function() {
//       var name = $(this).attr('id');
//       var thumb = "#" + name + "-thumb";
//       $(thumb).addClass( "visible" );
//     }, function() {
//       var name = $(this).attr('id');
//       var thumb = "#" + name + "-thumb";
//       $(thumb).removeClass( "visible" );
//     }
//   );
// }

var workThumbs = function() {
  $(".work-index ul li").mouseenter(
    function() {
      var name = $(this).attr('id');
      var thumb = "#" + name + "-thumb";
      //$('.desktop-thumbs__item').stop();
      $(thumb).addClass( "visible" );
      $(thumb).addClass( "front" );
      $(thumb).siblings().removeClass( "front" );
      setTimeout(function() {
       $(thumb).siblings().removeClass( "visible" );
     }, 0);
    });
}

export default workThumbs;



// WEBPACK FOOTER //
// ./source/scripts/modules/workthumbs.js